// 启动模块API接口

import utils from "../../../utils";
import { BaseApi } from "../../../utils/request";
import { LtProxy } from "../../../utils";
import { StartupData } from "../../../modules/startup/types";
import { datadogRum } from "@datadog/browser-rum";

// 启动数据API
export class StartupApi extends BaseApi {
  // 获取启动数据
  async getStartupData(lazy: boolean = true): Promise<StartupData> {
    const searchParams = new URLSearchParams(window.location.search);
    const startTime = Date.now();
    let url = `/api/home/startup?lazy=${lazy}&startTime=${startTime}`;
    const params = searchParams.get("p");
    if (params) {
      url += `&p=${params}`;
    }
    // 开发环境添加dev参数
    if (process.env.NODE_ENV === "development") {
      url += "&dev=true";
    }

    // 如果是应用环境，检查剪贴板数据
    if (
      typeof window !== "undefined" &&
      window.navigator?.userAgent &&
      utils.isApp()
    ) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          const clipboardData = await navigator.clipboard.readText();
          if (clipboardData.includes("W2A-")) {
            url += `&wta=${clipboardData.replace("W2A-", "")}`;
          }
        }
      } catch {
        // 剪贴板访问失败，忽略错误
      }
    }

    const response = await this.get<StartupData>(
      url,
      {},
      {
        cache: true,
        cacheTime: 5 * 60 * 1000, // 5分钟缓存
        alert: false,
      }
    );
    if (response.status === 0) {
      // 处理构建配置
      if (response.data?.buildConfig) {
        const needAppend =
          !(window as any)._config || !(window as any)._config.varStyles;
        if (!(window as any)._config) {
          (window as any)._config = response.data.buildConfig;
        }
        if (needAppend && response.data.buildConfig.varStyles) {
          document.body.style.cssText =
            (document.body.style.cssText || "") +
            response.data.buildConfig.varStyles;
        }
      }
      // 设置 Datadog RUM 商户标签
      if (response.data?.brand) {
        datadogRum.setGlobalContextProperty("merchant", response.data.brand.name);
        datadogRum.setGlobalContextProperty("merchantId", response.data.brand.id);
      }
      if (
        utils.hasProperty(response.data, "horizontalCom") &&
        response.data?.horizontalCom
      ) {
        LtProxy.enterFullScreen();
        LtProxy.landScreen();
      }
    }
    return response.data;
  }
}

// 创建API实例
export const startupApi = new StartupApi();
